import Loading from '@/components/general/Loading';
import StaffMemberNotesComponent from './StaffMemberNotes.component';
import { useStaffMemberInfoContext } from '../StaffMemberInfo/StaffMemberInfo.context';

const StaffMemberNotes = (): JSX.Element => {
  const { staffMember, refreshUser } = useStaffMemberInfoContext();

  if (!staffMember) {
    return <Loading fullPage />;
  }

  return (
    <StaffMemberNotesComponent refetchCandidate={refreshUser} candidate={staffMember.person} />
  );
};

export default StaffMemberNotes;
